<section class="d-flex align-items-center dark-overlay bg-cover heroHome">
  <div class="container py-5 py-md-6 py-lg-6 text-white overlay-content text-center">
    <div class="row">
      <div class="col-xl-10 mx-auto">
        <div class="py-6 py-xl-5  d-none d-lg-block"></div>
        <h1 class="display-5 fw-bold text-shadow">Vacations In Style</h1>
        <p class="text-lg text-shadow home-hero-subtitle">
          Uncover the best accomodations in Cyprus.
        </p>
      </div>
    </div>
  </div>
</section>
<div class="container">
  <form [formGroup]="myForm" class="home-airbnb-search-wrap mt-n5 z-index-20">
    <ng-container *ngIf="!smallDevice; else mobileSearchTemplate">
      <div class="home-airbnb-search" [class.home-airbnb-search--expanded]="desktopActivePanel !== null">
        <div class="home-airbnb-search__shell">
          <div class="home-airbnb-search__segment home-airbnb-search__segment--where"
            [class.is-active]="desktopActivePanel === 'where'" (click)="activateDesktopPanel('where')">
            <div class="home-airbnb-search__segment-label">Where</div>
            <app-location-typeahead #homeWhereTypeahead class="home-airbnb-search__typeahead"
              [formControlName]="'location'" [placeholder]="'Search destinations'" [renderSuggestionsInline]="false"
              [emptyStateSuggestions]="homeEmptyStateSuggestions" (locationSelected)="onLocationSelected($event)"
              (firstSuggestionChange)="onLocationFirstSuggestionChanged($event)">
            </app-location-typeahead>
          </div>

          <button type="button" class="home-airbnb-search__segment" [class.is-active]="desktopActivePanel === 'when'"
            (click)="activateDesktopPanel('when')">
            <span class="home-airbnb-search__segment-label">When</span>
            <span class="home-airbnb-search__segment-value">
              <span>{{ getWhenSummary() }}</span>
              <span *ngIf="getWhenFlexibilitySummary()" class="home-airbnb-search__segment-meta">{{
                getWhenFlexibilitySummary() }}</span>
            </span>
          </button>

          <button type="button" class="home-airbnb-search__segment" [class.is-active]="desktopActivePanel === 'who'"
            (click)="activateDesktopPanel('who')">
            <span class="home-airbnb-search__segment-label">Who</span>
            <span class="home-airbnb-search__segment-value">{{ getWhoSummary() }}</span>
          </button>

          <button type="button" class="home-airbnb-search__submit" (click)="onSubmit()">
            <i class="fa-solid fa-magnifying-glass"></i>
            <span>Search</span>
          </button>
        </div>

        <div class="home-airbnb-search__panel" *ngIf="desktopActivePanel === 'when'">
          <app-inline-calendar [calendarLayout]="'inline'" [startDate]="startDate" [endDate]="endDate"
            [calendarOptions]="calendarOptions" (datesSelected)="onDatesSelectedT($event)">
          </app-inline-calendar>

          <div class="search-flexibility">
            <div class="search-flexibility__options">
              <button type="button" class="search-flexibility__option" *ngFor="let option of flexibilityOptions"
                [class.is-active]="dateFlexibility === option.days" (click)="setDateFlexibility(option.days)">
                {{ option.label }}
              </button>
            </div>

            <button type="button" class="search-flexibility__action" *ngIf="startDate && endDate"
              (click)="onDesktopDatesNext()">
              Next
            </button>
          </div>
        </div>

        <div class="home-airbnb-search__panel home-airbnb-search__panel--guests" *ngIf="desktopActivePanel === 'who'">
          <app-guest-picker [guests]="guestSelection" (guestsChanged)="onGuestsChanged($event)"></app-guest-picker>
        </div>
      </div>
    </ng-container>

    <ng-template #mobileSearchTemplate>
      <div class="home-mobile-search ">
        <button type="button" class="home-mobile-search__entry" (click)="openMobileSearch()"
          aria-label="Open search dialog">
          <span class="home-mobile-search__entry-icon"><i class="fa-solid fa-magnifying-glass"></i></span>
          <span class="home-mobile-search__entry-main">
            <span class="home-mobile-search__entry-title">Start your search</span>
            <span class="home-mobile-search__entry-sub">{{ getWhereSummary() }} • {{ getWhenSummary() }} • {{
              getWhoSummary() }}</span>
          </span>
          <span class="home-mobile-search__entry-arrow"><i class="fa-solid fa-sliders"></i></span>
        </button>


      </div>
    </ng-template>
  </form>
</div>
<section *ngIf="!smallDevice" class="py-4">
  <div class="container">
    <div class="text-center pb-lg-4">
      <h2 class="mb-4">Booking with us is easy</h2>
    </div>
    <div class="row">
      <div class="col-lg-4 mb-3 mb-lg-0 text-center">
        <div class="px-0 px-lg-3">
          <div class="icon-rounded bg-secondary-light text-secondary mb-3">
            <i class="fas fa-map-marked-alt fa-2x"></i>
          </div>
          <h3 class="h5">Find the perfect rental</h3>
          <p class="text-muted">
            - Search our website to find the best rental for your vacation.
            <br />
            - Use the website chat to speak with one of our rental specialists
            to get help finding the perfect rental
          </p>
        </div>
      </div>
      <div class="col-lg-4 mb-3 mb-lg-0 text-center">
        <div class="px-0 px-lg-3">
          <div class="icon-rounded bg-secondary-light text-secondary mb-3">
            <i class="far fa-credit-card fa-2x"></i>
          </div>
          <h3 class="h5">Book with confidence</h3>
          <p class="text-muted">
            Meaning: Our Dedicated team is always there to answer any questions
            before and after booking, during your stay and after your vacation
            is over.<br />
            The data transmitted is always Encrypted for your safety
          </p>
        </div>
      </div>
      <div class="col-lg-4 mb-3 mb-lg-0 text-center">
        <div class="px-0 px-lg-3">
          <div class="icon-rounded bg-secondary-light text-secondary mb-3">
            <i class="far fa-grin-hearts fa-2x"></i>
          </div>
          <h3 class="h5">Best Price Guaranteed</h3>
          <p class="text-muted">
            Found a lower price elsewhere? No problem! If you find a lower price
            elsewhere within 24 hours of booking, we will match the lower rate
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
<section *ngIf="hasRecentlyViewedProperties()" class="py-3 bg-gray-100">
  <div class="container">
    <div class="row mb-2">
      <div class="col-md-8">
        <h2>Pick Up Where You Left Off</h2>
        <p class="text-muted mb-0">Last Visited Rentals ({{ recentlyViewedProperties.length }})</p>
      </div>
    </div>

    <ng-container *ngIf="smallDevice; else desktopRecentlyViewedCarousel">
      <div class="recently-viewed-mobile-row">
        <a class="recently-viewed-mobile-card" *ngFor="let item of recentlyViewedProperties"
          [routerLink]="['/accomodation/' + item.id + '/' + item.slug]" (click)="onRecentlyViewedClick(item)">
          <div class="recently-viewed-mobile-card__media">
            <img loading="lazy" [src]="getRecentlyViewedImage(item)" [alt]="item.t" class="img-fluid" />
          </div>
          <div class="recently-viewed-mobile-card__title">{{ item.t }}</div>
        </a>
      </div>
    </ng-container>

    <ng-template #desktopRecentlyViewedCarousel>
      <div class="view-again-carousel-wrap" (touchstart)="onRecentlyViewedTouchStart($event)"
        (touchend)="onRecentlyViewedTouchEnd($event)">
        <owl-carousel-o #recentlyViewedOwl [options]="recentlyViewedCarouselOptions"
          (translated)="onRecentlyViewedTranslated()" class="view-again-carousel">
          <ng-container *ngFor="let item of recentlyViewedProperties; let i = index">
            <ng-template carouselSlide [id]="'view-again-' + item.id + '-' + i">
              <div class="w-100 h-100 hover-animate">
                <div class="card h-100 border-0 shadow view-again-card">
                  <div class="card-img-top overflow-hidden gradient-overlay rounded-3 view-again-card__media">
                    <img loading="lazy" [src]="getRecentlyViewedImage(item)" [alt]="item.t" class="img-fluid" />
                    <a [routerLink]="['/accomodation/' + item.id + '/' + item.slug]" class="tile-link"
                      (click)="onRecentlyViewedClick(item)"></a>
                    <div class="view-again-item-index">{{ i + 1 }}</div>
                    <div class="card-img-overlay-top view-again-card__title-wrap">
                      <h6 class="view-again-card__title mb-0">{{ item.t }}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
    </ng-template>
  </div>
</section>
<section class="py-3 bg-white">
  <div class="container">
    <div class="row mb-2">
      <div class="col-md-8">
        <h2>Featured Rentals</h2>
      </div>
      <div class="col-md-4 d-lg-flex align-items-center justify-content-end">

        <a [routerLink]="['/search/Anywhere/rentals']" *ngIf="!smallDevice"
          [queryParams]=" {dates:'',adults:2,children:0,infant:0,place_id:''}" class="text-muted text-sm">
          See All Rentals<i class="fas fa-angle-double-right ms-2"></i></a>
      </div>
    </div>

    <div class="row">
      <!-- blog item-->
      <ng-container *ngIf="homePageInfo$ | async as hp">
        <ng-container *ngIf="hp.featured.length">
          <div class="col-lg-3 col-sm-6 mb-4 hover-animate" *ngFor="let featuredProperty of hp.featured">
            <div class="w-100 h-100 hover-animate ">
              <div class="card h-100 border-0 shadow">
                <div class="card-img-top overflow-hidden gradient-overlay rounded-3">
                  <img loading="lazy" data-src="https://myexclusivevillas.com/storage/p/{{
                      featuredProperty.id
                    }}/{{ featuredProperty.photo }}" alt="{{ featuredProperty.t }}{{ featuredProperty.fn }}"
                    class="img-fluid" />

                  <a [routerLink]="[
                      '/accomodation/' +
                        featuredProperty.id +
                        '/' +
                        featuredProperty.slug
                    ]" class="tile-link"></a>
                  <div class="card-img-overlay-bottom z-index-20">
                    <div class="media text-white text-sm align-items-center">
                      <div class="media-body"></div>
                    </div>
                  </div>
                  <div class="card-img-overlay-top text-end"></div>
                </div>
                <div class="card-body d-flex align-items-center ">
                  <div class="w-100">
                    <h6 class="card-title">
                      <a [routerLink]="[
                          '/accomodation/' +
                            featuredProperty.id +
                            '/' +
                            featuredProperty.slug
                        ]" class="text-decoration-none text-dark">{{ featuredProperty.t }}</a>
                    </h6>
                    <div class="d-flex card-subtitle mb-3">
                      <p class="grow mb-0 text-muted text-sm">
                        {{ featuredProperty.ty }}
                      </p>
                      <p class="shrink mb-0 card-stars text-xs text-end">
                        <app-star-rating [rating]="featuredProperty.avg"></app-star-rating>
                      </p>
                    </div>
                    <p class="card-text text-muted">
                      <span class="h4 text-primary">{{
                        featuredProperty.avga
                        | currency : "EUR" : "symbol" : "1.0-0"
                        }}</span>
                      average per night
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</section>

<!-- Our picks section-->
<section class="py-3">
  <div class="container">
    <div class="row mb-5">
      <div class="col-md-8">
        <p class="subtitle text-primary">Hot Locations</p>
        <h2>Popular Locations</h2>
      </div>
      <div class="col-md-4 d-md-flex align-items-center justify-content-end">
        <a href="/areas" class="text-muted text-sm">
          See all Locations<i class="fas fa-angle-double-right ms-2"></i></a>
      </div>
    </div>
    <div class="row">
      <div class="d-flex align-items-lg-stretch mb-4 col-lg-8">
        <div style="
            background: center center
              url(/assets/Nissi_26_03_19_005-n640x480.jpg) no-repeat;
            background-size: cover;
          " class="card shadow-lg border-0 w-100 hover-animate">
          <a [routerLink]="'/areas/Ayia-Napa'" class="tile-link"> </a>
          <div class="d-flex align-items-center h-100 text-white justify-content-center py-6 py-lg-7">
            <h3 class="text-shadow text-uppercase mb-0">Ayia Napa</h3>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-lg-stretch mb-4 col-lg-4">
        <div style="
            background: center center
              url(/assets/FigTreeBay_smSlider-n620x440.jpg) no-repeat;
            background-size: cover;
          " class="card shadow-lg border-0 w-100 hover-animate">
          <a [routerLink]="'/areas/Protaras'" class="tile-link"> </a>
          <div class="d-flex align-items-center h-100 text-white justify-content-center py-6 py-lg-7">
            <h3 class="text-shadow text-uppercase mb-0">Protaras</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="d-flex align-items-lg-stretch mb-4 col-lg-4" *ngIf="!smallDevice && loaded">
        <div style="
            background: center center
              url(/assets/AyiaTheklaBeach_4-n700x480.jpg) no-repeat;
            background-size: cover;
          " class="card shadow-lg border-0 w-100 hover-animate">
          <a [routerLink]="'/areas/Ayia-Thekla'" class="tile-link"> </a>
          <div class="d-flex align-items-center h-100 text-white justify-content-center py-6 py-lg-7">
            <h3 class="text-shadow text-uppercase mb-0">Ayia Thekla</h3>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-lg-stretch mb-4 col-lg-4" *ngIf="!smallDevice && loaded">
        <div style="
            background: center center
              url(/assets/Limassol_marina_1_-n700x480.jpg) no-repeat;
            background-size: cover;
          " class="card shadow-lg border-0 w-100 hover-animate">
          <a [routerLink]="'/areas/Larnaca-Town'" class="tile-link"> </a>
          <div class="d-flex align-items-center h-100 text-white justify-content-center py-6 py-lg-7">
            <h3 class="text-shadow text-uppercase mb-0">Larnaca</h3>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-lg-stretch mb-4 col-lg-4">
        <div style="
            background: center center url(/assets/Coral_Bay_sm-n700x480.jpg)
              no-repeat;
            background-size: cover;
          " class="card shadow-lg border-0 w-100 hover-animate">
          <a [routerLink]="'/areas/coral-bay'" class="tile-link"> </a>
          <div class="d-flex align-items-center h-100 text-white justify-content-center py-6 py-lg-7">
            <h3 class="text-shadow text-uppercase mb-0">Coral Bay</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Divider Section-->
<!-- <section class="py-7 position-relative dark-overlay">
  <img src="/assets/DJI_0494-n1300x500.jpg" alt="" class="bg-image" />
  <div class="container">
    <div class="overlay-content text-white py-lg-5">
      <h3 class="display-3 fw-bold text-serif text-shadow mb-5">
        Photos from our Guests
      </h3>
      <a href="category-rooms.html" class="btn btn-light">View Galleries</a>
    </div>
  </div>
</section> -->
<section class="py-6 bg-gray-100">
  <div class="container">
    <div class="row mb-5">
      <div class="col-md-8">
        <p class="subtitle text-secondary">
          News, Events related to Travel and Tourism
        </p>
        <h2>Travel blog</h2>
      </div>
      <div class="col-md-4 d-md-flex align-items-center justify-content-end">
        <a [routerLink]="['/blog']" class="text-muted text-sm">
          See all articles<i class="fas fa-angle-double-right ms-2"></i></a>
      </div>
    </div>
    <div class="row">
      <!-- blog item-->
      <ng-container *ngIf="homePageInfo$ | async as hp">
        <ng-container *ngIf="hp.posts.length">
          <div class="col-lg-4 col-sm-6 mb-4 hover-animate" *ngFor="let post of hp.posts">
            <div class="card shadow border-0 h-100">
              <a [routerLink]="['/blog/' + post.id + '/' + post.slug]"><img src="{{ post.image }}" alt="{{ post.title }}" class="rounded-3 img-fluid card-img-top" width="340"
                  height="220" loading="lazy" /></a>
              <div class="card-body">
                <h5 class="my-2">
                  <a [routerLink]="['/blog/' + post.id + '/' + post.slug]" class="text-dark">{{ post.title }}
                  </a>
                </h5>
                <p class="text-gray-500 text-sm my-3">
                  <i class="far fa-clock me-2"></i>{{ post.post_at | date }}
                </p>
                <p class="my-2 text-muted text-sm"></p>
                <a [routerLink]="['/blog/' + post.id + '/' + post.slug]" class="btn btn-link ps-0">Read more<i
                    class="fa fa-long-arrow-alt-right ms-2"></i></a>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</section>
<!--  Templates -->